import { ref, onBeforeMount } from 'vue';
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-20b753ff"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "mainpage"
};
const _hoisted_2 = {
  class: "search_block"
};
const _hoisted_3 = {
  class: "table-content"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = {
  key: 1
};
const _hoisted_6 = {
  key: 1
};
const _hoisted_7 = {
  key: 3
};
import { payStatusList, orderTypeList, getPropertyByIdAndKey } from './data';
import searchBlock from './components/SearchBlock.vue';
import OrderDrawer from './components/OrderDrawer.vue';
import { getMockOrderListFetch } from '@/api/sandbox';
import { reportEvent } from '@/common';
import { columns } from './data';
import { defineComponent } from 'vue';
const __default__ = defineComponent({
  name: 'mockOrderQuery'
});
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {
    const pageNum = ref(1);
    const pageSize = ref(20);
    const pageTotal = ref(0);
    const dataSource = ref([]);
    const loading = ref(false);
    const orderDrawerVisible = ref(false);
    const filterOptions = ref({});
    const orderInfo = ref();
    // 删除空值属性
    function removeEmptyParams(obj) {
      return Object.fromEntries(Object.entries(obj).filter(([_, value]) => {
        return !(value === null || value === undefined || typeof value === 'string' && value.trim() === '' || Array.isArray(value) && value.length === 0 || Object.prototype.toString.call(value) === '[object Object]' && Object.keys(value).length === 0);
      }));
    }
    const getParams = () => {
      const params = {
        pageNum: pageNum.value,
        pageSize: pageSize.value,
        ...filterOptions.value
      };
      return removeEmptyParams(params);
    };
    const showOrderDetail = record => {
      orderDrawerVisible.value = true;
      orderInfo.value = {
        ...record
      };
      reportEvent({
        eventName: 'element_use',
        properties: {
          ui_name: 'MOCK订单查询',
          element_name: '查看详情'
        }
      });
    };
    const changePage = async (page, pageS) => {
      pageNum.value = page;
      pageSize.value = pageS;
      getList();
    };
    const getList = async () => {
      try {
        const params = getParams();
        loading.value = true;
        const {
          code,
          data
        } = await getMockOrderListFetch(params);
        if (code === '0000') {
          var _data$thirdOrderList, _data$total;
          dataSource.value = (_data$thirdOrderList = data === null || data === void 0 ? void 0 : data.thirdOrderList) !== null && _data$thirdOrderList !== void 0 ? _data$thirdOrderList : [];
          pageTotal.value = (_data$total = data.total) !== null && _data$total !== void 0 ? _data$total : 0;
          return 'succeed';
        }
        return 'failed';
      } catch (error) {
        return 'failed';
      } finally {
        loading.value = false;
      }
    };
    const getListBySearch = async () => {
      const startTime = new Date().getTime();
      const status = await getList();
      const duartion = new Date().getTime() - startTime;
      reportEvent({
        eventName: '_search',
        properties: {
          ui_name: 'MOCK订单管理',
          app_name: '',
          return_duration: duartion / 1000,
          query_status: status
        }
      });
    };
    const onSearch = options => {
      pageNum.value = 1;
      filterOptions.value = {
        ...options
      };
      getListBySearch();
    };
    onBeforeMount(() => {
      pageNum.value = 1;
      getList();
    });
    return (_ctx, _cache) => {
      const _component_a_tag = _resolveComponent("a-tag");
      const _component_a_table = _resolveComponent("a-table");
      const _component_a_pagination = _resolveComponent("a-pagination");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(searchBlock, {
        payStatusList: _unref(payStatusList),
        orderTypeList: _unref(orderTypeList),
        onSearch: onSearch
      }, null, 8, ["payStatusList", "orderTypeList"])]), _createElementVNode("div", _hoisted_3, [_createVNode(_component_a_table, {
        class: "tableBody",
        bordered: "",
        loading: loading.value,
        columns: _unref(columns),
        "data-source": dataSource.value,
        "row-key": "key",
        pagination: false
      }, {
        bodyCell: _withCtx(({
          column,
          record
        }) => [column.dataIndex === 'orderNo' ? (_openBlock(), _createElementBlock("a", {
          key: 0,
          onClick: $event => showOrderDetail(record)
        }, _toDisplayString(record.orderNo), 9, _hoisted_4)) : column.dataIndex === 'payMethod' ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, [_unref(getPropertyByIdAndKey)(record.payMethod, 'label', _unref(orderTypeList)) ? (_openBlock(), _createBlock(_component_a_tag, {
          key: 0,
          class: "custom_tag",
          color: _unref(getPropertyByIdAndKey)(record.payMethod, 'color', _unref(orderTypeList)),
          bordered: false
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(getPropertyByIdAndKey)(record.payMethod, 'label', _unref(orderTypeList))), 1)]),
          _: 2
        }, 1032, ["color"])) : (_openBlock(), _createElementBlock("div", _hoisted_5, "--"))], 64)) : column.dataIndex === 'payStatus' ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 2
        }, [_unref(getPropertyByIdAndKey)(record.payStatus, 'label', _unref(payStatusList)) ? (_openBlock(), _createBlock(_component_a_tag, {
          key: 0,
          class: "custom_tag",
          color: _unref(getPropertyByIdAndKey)(record.payStatus, 'color', _unref(payStatusList)),
          bordered: false
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(getPropertyByIdAndKey)(record.payStatus, 'label', _unref(payStatusList))), 1)]),
          _: 2
        }, 1032, ["color"])) : (_openBlock(), _createElementBlock("div", _hoisted_6, "--"))], 64)) : (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString((record === null || record === void 0 ? void 0 : record[column.dataIndex]) || '--'), 1))]),
        _: 1
      }, 8, ["loading", "columns", "data-source"]), _createVNode(_component_a_pagination, {
        onChange: changePage,
        current: pageNum.value,
        "onUpdate:current": _cache[0] || (_cache[0] = $event => pageNum.value = $event),
        pageSize: pageSize.value,
        "onUpdate:pageSize": _cache[1] || (_cache[1] = $event => pageSize.value = $event),
        total: pageTotal.value,
        "show-size-changer": "",
        "show-total": total => `共 ${total} 条`
      }, null, 8, ["current", "pageSize", "total", "show-total"])]), _createVNode(OrderDrawer, {
        modalVisible: orderDrawerVisible.value,
        "onUpdate:modalVisible": _cache[2] || (_cache[2] = $event => orderDrawerVisible.value = $event),
        orderInfo: orderInfo.value
      }, null, 8, ["modalVisible", "orderInfo"])]);
    };
  }
});